(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["inside-nh-pdp-module"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Lazy video start (NH-CODE-101, 2026-10-05): the videos ship preload="none"
       with no native autoplay, so this module costs zero video bytes on page load.
       Start them when the module approaches the viewport, unless the visitor
       prefers reduced motion. The pause/play toggles below still work either way.

       This runs BEFORE the toggle early-return on purpose: a layout with videos
       but no toggle would otherwise never start playback at all. */
    var pdpReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var pdpVideos = document.querySelectorAll('[data-inside-nh-pdp-video]');
    if (pdpVideos.length && 'IntersectionObserver' in window) {
      var pdpVideoIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (!pdpReducedMotion.matches) {
            var p = entry.target.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          }
          pdpVideoIo.unobserve(entry.target);
        });
      }, { rootMargin: '200px 0px' });
      pdpVideos.forEach(function (v) { pdpVideoIo.observe(v); });
    }

    var toggles = document.querySelectorAll('[data-inside-nh-pdp-video-toggle]');
    if (!toggles.length) return;

    toggles.forEach(function (toggle) {
      /* The video sits next to the toggle inside the same section (cinematic)
         or inside the duo-wrap (two-card). Walk up until we find a container. */
      var scope = toggle.closest('.inside-nh-pdp-module__duo-wrap')
               || toggle.closest('.inside-nh-pdp-module');
      var video = scope ? scope.querySelector('[data-inside-nh-pdp-video]') : null;
      if (!video) return;

      var labelEl = toggle.querySelector('[data-inside-nh-pdp-video-label]');
      var labelPause = toggle.getAttribute('data-label-pause');
      var labelPlay = toggle.getAttribute('data-label-play');

      function setState(isPlaying) {
        if (isPlaying) {
          toggle.setAttribute('data-state', 'pause');
          toggle.setAttribute('aria-pressed', 'true');
          toggle.setAttribute('aria-label', labelPause);
          if (labelEl) labelEl.textContent = labelPause;
        } else {
          toggle.setAttribute('data-state', 'play');
          toggle.setAttribute('aria-pressed', 'false');
          toggle.setAttribute('aria-label', labelPlay);
          if (labelEl) labelEl.textContent = labelPlay;
        }
      }

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (video.paused) {
          var p = video.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
          setState(true);
        } else {
          video.pause();
          setState(false);
        }
      });

      video.addEventListener('play', function () { setState(true); });
      video.addEventListener('pause', function () { setState(false); });

      /* Respect prefers-reduced-motion: pause by default. */
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        try { video.pause(); } catch (err) {}
        setState(false);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inside-nh-teaser"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var teasers = document.querySelectorAll('[data-inside-nh-teaser]');
    if (!teasers.length) return;

    teasers.forEach(function (teaser) {
      var track = teaser.querySelector('[data-inside-nh-teaser-track]');
      var prevBtn = teaser.querySelector('[data-inside-nh-teaser-prev]');
      var nextBtn = teaser.querySelector('[data-inside-nh-teaser-next]');
      if (!track || !prevBtn || !nextBtn) return;

      var counterCurrent = teaser.querySelector('[data-inside-nh-teaser-counter-current]');
      var counterSr = teaser.querySelector('[data-inside-nh-teaser-counter-sr]');
      var segments = teaser.querySelectorAll('[data-inside-nh-teaser-segment]');
      var chapterCards = teaser.querySelectorAll('.inside-nh-teaser__card-wrap');
      var srTemplate = counterSr ? counterSr.getAttribute('data-template') || '' : '';

      function pad2(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function cardStep() {
        var first = track.querySelector('.inside-nh-teaser__card-wrap') || track.querySelector('.inside-nh-teaser__card');
        if (!first) return 400;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '24') || 24;
        return first.offsetWidth + gap;
      }

      /* Index of the chapter card currently "leading" the viewport. */
      function activeChapterIndex() {
        if (!chapterCards.length) return 0;
        var trackLeft = track.getBoundingClientRect().left;
        var bestIdx = 0;
        var bestDist = Infinity;
        for (var i = 0; i < chapterCards.length; i++) {
          var dist = Math.abs(chapterCards[i].getBoundingClientRect().left - trackLeft);
          if (dist < bestDist) { bestDist = dist; bestIdx = i; }
        }
        return bestIdx;
      }

      var lastIdx = -1;
      function update() {
        var totalScroll = track.scrollWidth - track.clientWidth;
        prevBtn.setAttribute('aria-disabled', String(track.scrollLeft <= 2));
        nextBtn.setAttribute('aria-disabled', String(totalScroll <= 0 || track.scrollLeft >= totalScroll - 2));

        var idx = activeChapterIndex();
        if (idx === lastIdx) return;
        lastIdx = idx;

        if (counterCurrent) counterCurrent.textContent = pad2(idx + 1);
        if (counterSr && srTemplate) {
          counterSr.textContent = srTemplate.replace('__CURRENT__', String(idx + 1));
        }
        for (var s = 0; s < segments.length; s++) {
          if (s <= idx) segments[s].classList.add('is-active');
          else segments[s].classList.remove('is-active');
        }
      }

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);

      prevBtn.addEventListener('click', function() {
        if (prevBtn.getAttribute('aria-disabled') === 'true') return;
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function() {
        if (nextBtn.getAttribute('aria-disabled') === 'true') return;
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });

      /* Keyboard support — track gets focus, left/right move the carousel. */
      track.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); prevBtn.click(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); nextBtn.click(); }
        if (e.key === 'Home')       { e.preventDefault(); track.scrollTo({ left: 0, behavior: 'smooth' }); }
        if (e.key === 'End')        { e.preventDefault(); track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); }
      });

      /* Click-card-to-advance: a partially-visible card scrolls into view
         instead of navigating away. Fully-visible cards behave like normal links. */
      var allCards = teaser.querySelectorAll('.inside-nh-teaser__card-wrap, .inside-nh-teaser__card--final');
      var ratios = new WeakMap();
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            ratios.set(entry.target, entry.intersectionRatio);
          });
        }, { root: track, threshold: [0, 0.25, 0.5, 0.75, 0.95, 1] });
        allCards.forEach(function (card) { io.observe(card); });
      }

      /* Peek option A (audit 2026-08-04, approved): a card that is not
         essentially fully in view hides its eyebrow and headline, so the sliver
         shows imagery only rather than slicing the text mid-phrase —
         "Trois ateliers, une Maison." was losing "une" and reading as
         "TROIS ATELIERS MAISON."

         Measured from geometry on scroll rather than from IntersectionObserver
         ratios. The observer's first callback can report a ratio captured
         before layout settles (fonts, lazy media), and a card that afterwards
         never crosses a threshold keeps that stale value forever — which
         showed up as fully visible desktop cards rendering with no text at
         all. Recomputing against the track's own box is deterministic and
         costs one rect read per card per animation frame. */
      function nhSyncClippedCards() {
        var tr = track.getBoundingClientRect();
        if (!tr.width) return;
        allCards.forEach(function (card) {
          var r = card.getBoundingClientRect();
          if (!r.width) return;
          var visible = Math.max(0, Math.min(r.right, tr.right) - Math.max(r.left, tr.left));
          card.classList.toggle('is-clipped', visible / r.width < 0.9);
        });
      }

      var nhClipFrame = null;
      function nhQueueClipSync() {
        if (nhClipFrame) return;
        nhClipFrame = requestAnimationFrame(function () {
          nhClipFrame = null;
          nhSyncClippedCards();
        });
      }

      track.addEventListener('scroll', nhQueueClipSync, { passive: true });
      window.addEventListener('resize', nhQueueClipSync);
      window.addEventListener('load', nhQueueClipSync);
      if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
        document.fonts.ready.then(nhQueueClipSync);
      }
      nhSyncClippedCards();
      allCards.forEach(function (card) {
        card.addEventListener('click', function (e) {
          var ratio = ratios.get(card);
          if (e.detail > 0 && typeof ratio === 'number' && ratio < 0.9) {
            e.preventDefault();
            if (typeof card.scrollIntoView === 'function') {
              card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
            } else {
              track.scrollTo({ left: card.offsetLeft, behavior: 'smooth' });
            }
          }
        });
      });

      /* Lazy video start (2026-08-04 audit): videos ship preload="none"
         without native autoplay, so the below-fold section costs zero video
         bytes on page load. Start them when the card track approaches the
         viewport, unless the visitor prefers reduced motion — the pause/play
         toggles below still work either way. */
      var teaserReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      var teaserVideos = teaser.querySelectorAll('[data-inside-nh-teaser-video]');
      if (teaserVideos.length && 'IntersectionObserver' in window) {
        var videoIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            if (!teaserReducedMotion.matches) {
              var p = entry.target.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            }
            videoIo.unobserve(entry.target);
          });
        }, { rootMargin: '200px 0px' });
        teaserVideos.forEach(function (v) { videoIo.observe(v); });
      }

      /* Video pause/play toggles (WCAG 2.2.2). */
      var toggles = teaser.querySelectorAll('[data-inside-nh-teaser-video-toggle]');
      toggles.forEach(function (toggle) {
        var wrap = toggle.closest('.inside-nh-teaser__card-wrap');
        var video = wrap ? wrap.querySelector('[data-inside-nh-teaser-video]') : null;
        if (!video) return;
        var labelEl = toggle.querySelector('[data-inside-nh-teaser-video-label]');
        var labelPause = toggle.getAttribute('data-label-pause');
        var labelPlay = toggle.getAttribute('data-label-play');

        function setState(isPlaying) {
          if (isPlaying) {
            toggle.setAttribute('data-state', 'pause');
            toggle.setAttribute('aria-pressed', 'true');
            toggle.setAttribute('aria-label', labelPause);
            if (labelEl) labelEl.textContent = labelPause;
          } else {
            toggle.setAttribute('data-state', 'play');
            toggle.setAttribute('aria-pressed', 'false');
            toggle.setAttribute('aria-label', labelPlay);
            if (labelEl) labelEl.textContent = labelPlay;
          }
        }

        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (video.paused) {
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function(){});
            setState(true);
          } else {
            video.pause();
            setState(false);
          }
        });

        video.addEventListener('play', function () { setState(true); });
        video.addEventListener('pause', function () { setState(false); });

        /* Respect prefers-reduced-motion: pause by default. */
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          try { video.pause(); } catch (err) {}
          setState(false);
        }
      });

      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
